import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSubscription } from '@apollo/react-hooks';
import { CLAIMS_FOR_AREA_BY_PROVIDER } from '../../hasura/queries/area/areaClaims';
import { AreaMapping } from '../../components/area/areaMapping';
import { Error } from '../../components/util/notifications';
import { Progress } from '../../components/util/progress';

function AreaMapper(props) {
  const query = new URLSearchParams(useLocation().search);
  const provider_area_id = query.get('provider_area_id');
  const provider = query.get('provider');

  const { loading, error, data } = useSubscription(CLAIMS_FOR_AREA_BY_PROVIDER, {
    variables: {
      provider_area_id: provider_area_id,
      provider,
    },
  });

  if (loading) return <Progress />;

  return (
    <>
      <Error message="Error fetching Claims for Area" error={error} />
      <AreaMapping claims={data?.claim_area || []} provider_area_id={provider_area_id} />
    </>
  );
}

export default AreaMapper;
